import { mapGetters } from "vuex";

export const categoryNavigation = {
  computed: {
    ...mapGetters({
      getNavItems: "navigation/getNavItems",
      getNavItemsMobile: "navigation/getNavItemsMobile",
      getCurrentNavItem: "navigation/getCurrentNavItem"
    })
  },
  methods: {
    navigateToCategory(navItem) {
      this.$store.commit("navigation/setCurrentNavItem", navItem);
      const overviewRegex = /clothing|shoes|accessories/;
      if (overviewRegex.test(navItem.name)) {
        this.$store.commit("filters/setFieldByKeyValue", {
          key: "category",
          value: navItem.name
        });
      }
      if (navItem === "sale") {
        this.$store.commit("filters/setFieldByKeyValue", {
          key: "onSale",
          value: true
        });
      }
      this.$router.push({ name: navItem.name });
    },
    isCurrentNav(navItem) {
      return this.getCurrentNavItem === navItem;
    },
    isHighlightedNav(navItem) {
      return navItem.highlighted;
    }
  }
};
